import React from 'react';
import { Link } from 'react-router-dom';
import
    { FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withRouter, RouteComponentProps } from 'react-router';

import Application from '../components/app/Application';
import { withTranslation, WithTranslation } from 'react-i18next';


interface Props extends RouteComponentProps, WithTranslation
{
}
interface State
{
}

/**
 * @author Germán Martínez
 */
class RouteTools extends React.Component<Props,State>
{
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.tools')}</h1>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/box-shadow">{t('titles.toolsBoxShadowGenerator')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/border-radius">{t('titles.toolsBorderRadiusGenerator')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/text-shadow">{t('titles.toolsTextShadowGenerator')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/filter">{t('titles.toolsFilterGenerator')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/color-picker">{t('titles.toolsColorPicker')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/url-encoder">{t('titles.toolsEncoderURL')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/base64-encoder">{t('titles.toolsEncoderBase64')}</Link>
    </FormGroup>
    <FormGroup>
        <Link to="/tools/image-crop">{t('toolImageCrop.title')}</Link>
    </FormGroup>
</Application>
        );
    }
};
export default withTranslation('common')(RouteTools);
